import * as React from "react";
import { connect } from "react-redux";
import { RouterState } from "react-router-redux";

import { TrackClick } from "../../../hoc";
import { RootState } from "../../../store/types";
import { history } from "../../../store";
import { Product } from "../../../models";
import * as selectors from "../selectors";
import { selectors as step1Selectors } from "../../Step1";
import Cart from "./Cart";
import NextStep from "./NextStep";
import PrevStep from "./PrevStep";
import "./Footer.css";

export interface FooterProps extends RouterState {
  nextStepPath: string;
  prevStepPath: string;
  isNextStepDisabled: boolean;
  chosenProduct?: Product;
}

class Footer extends React.Component<FooterProps> {
  public render() {
    const pathname = this.props.location ? this.props.location.pathname : "";

    return (
      <div className="container wizard-footer">
        <div className="row">
          <div className="col-md-8 col-md-offset-2">
            <div className="wizard-footer__container">
              <div className="wizard-footer__main">
                <TrackClick
                  category="wizard"
                  action="Clicked footer back button"
                  label={pathname}
                  onClick={this.goToPrevStep}
                  render={handleClick => (
                    <PrevStep goToPrevStep={handleClick} />
                  )}
                />
                <div className="wizard-footer__cart-container">
                  <Cart chosenProduct={this.props.chosenProduct} />
                </div>
                <TrackClick
                  category="wizard"
                  action="Clicked footer next button"
                  label={pathname}
                  onClick={this.goToNextStep}
                  render={handleClick => (
                    <NextStep
                      disabled={this.props.isNextStepDisabled}
                      goToNextStep={handleClick}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private goToNextStep = () => history.push(this.props.nextStepPath);
  private goToPrevStep = () => history.replace(this.props.prevStepPath);
}

const mapStateToProps = (state: RootState): Partial<FooterProps> => ({
  nextStepPath: selectors.nextWizardStep(state),
  prevStepPath: selectors.prevWizardStep(state),
  isNextStepDisabled: selectors.isWizardNextStepDisabled(state),
  chosenProduct: step1Selectors.chosenProduct(state),
});

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/routes/Wizard/components/Footer.tsx